// extracted by mini-css-extract-plugin
export var actionButton = "_pu-0";
export var actionMenuContainer = "_pu-i";
export var bubble = "_pu-2";
export var bubbleActionMenu = "_pu-j";
export var bubbleContext = "_pu-6";
export var bubbleItems = "_pu-7";
export var customer = "_pu-3";
export var divider = "_pu-8";
export var fileList = "_pu-9";
export var hiddenComment = "_pu-o";
export var infoAbove = "_pu-a";
export var internal = "_pu-4";
export var lightActionButton = "_pu-1";
export var link = "_pu-b";
export var merchant = "_pu-5";
export var message = "_pu-c";
export var profilePicture = "_pu-e";
export var quillToolbarContainer = "_pu-f";
export var senderDate = "_pu-g";
export var senderDateCustomer = "_pu-h";
export var senderName = "_pu-d";
export var time = "_pu-k";
export var uploadedImage = "_pu-l";
export var username = "_pu-m";
export var xsmall = "_pu-n";